import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6995507bf782d500145ffcff_1783492768228_1852def0/bestoddscorp/src/app/legal/trademarks/page.tsx");
